import {Injectable} from "@angular/core";
import {AppStore} from "../state/services/app-store";
import { RootState as PermissionsRootState } from '@k2/common/permissions-state/state';
import { select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { getPermissions } from '@k2/common/permissions-state/reducers';
import { toPermissionsGuard } from '@k2/common/permissions/permissions-guard';


@Injectable({ providedIn: 'root' })
export class IsAllowedService {
  constructor(private store: AppStore<PermissionsRootState>) {}

  isAllowed(expression: string): Observable<boolean> {
    return this.store.pipe(
      select(getPermissions),
      map(toPermissionsGuard(expression)),
      distinctUntilChanged()
    );
  }
}
